/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoodWareDishIcon16Regular = forwardRef('FoodWareDishIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8.75 3.8a1.5 1.5 0 1 0-1.5 0v.995a6.297 6.297 0 0 0-3.67 1.786A6.307 6.307 0 0 0 1.75 11a.75.75 0 0 0 1.5 0c0-1.248.51-2.477 1.391-3.359A4.793 4.793 0 0 1 8 6.25c1.248 0 2.477.51 3.359 1.391A4.793 4.793 0 0 1 12.75 11a.75.75 0 0 0 1.5 0c0-1.642-.67-3.259-1.83-4.42a6.297 6.297 0 0 0-3.67-1.785V3.8Z" }),
        React.createElement("path", { d: "M.75 12.5a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5H.75Z" })));
});
